
export enum DelivererType {
  FORWARDER = 'forwarder',
  RFS = 'rfs',
  INTERLINE = 'interline'
};
